import { Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConcessionarioPessoaStatus } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-status';
import { ConcessionarioPessoaTipoVinculo } from '@tivic-team/manager-ts/dist/mob/enums/concessionario-pessoa/concessionario-pessoa-tipo-vinculo';
import { Usuario } from '@tivic-team/manager-ts/dist/seg';
import { ConcessionarioPessoaDTO } from 'app/model/dtos/mob/concessionario-pessoa.dto';
import { LocalStorageService } from 'app/services/local-storage.service';
import { ConcessionarioPessoaService } from 'app/services/mob/concessionario-pessoa.service';
import { CustomFormBuilder } from 'app/tools/custom-form-builder';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { DialogFactory } from 'sol-tools-ts/dist';
import { ConcessionarioPessoaBuilder } from './concessionario-pessoa.builder';

@Component({
  selector: 'button-ativar',
  templateUrl: './button-ativar.component.html',
  styleUrls: ['./button-ativar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ButtonAtivarComponent implements OnInit {

  formGroup: FormGroup;
  reativar: string;
  concessionarioPessoaDTO: ConcessionarioPessoaDTO
  cdConcessao: number;
  usuario: Usuario;

  constructor(
    private _controlContainer: ControlContainer,
    private _router: Router,
    private _dialogFactory: DialogFactory,
    private _activatedRoute: ActivatedRoute,
    private _concessionarioPessoaService: ConcessionarioPessoaService,
    private _customForBuilder: CustomFormBuilder,
    private _localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.usuario = this._localStorage.usuario;
    this.concessionarioPessoaDTO = this.formGroup.getRawValue();
    this.formGroup.get("cdUsuarioCadastro").setValue(this.usuario.cdUsuario);
    this.nmTitulo;
  }

  ngAfterViewInit() {
    this.cdConcessao = this._activatedRoute.snapshot.params['cdConcessao'];
  }

  async ativar() {
    try {
      let concessionarioPessoaDTO: ConcessionarioPessoaDTO = this.formGroup.value;
      if(!concessionarioPessoaDTO.cdConcessionarioPessoa) {
      this._dialogFactory.snack('Não há um cadastro', 'OK', DialogFactory.SNACK_INFO);
      return;
    }
      const resposta = await this._dialogFactory
        .confirm(this.nmTitulo, 'Ao ativar a data final será removida. Deseja continuar?', 'Ativar', 'Cancelar')
        .toPromise();
      if (resposta) {
        this.buildSituacao(concessionarioPessoaDTO);
        this.setDtAtivacao();
        let resultado: ConcessionarioPessoaDTO = await this._concessionarioPessoaService.ativar(concessionarioPessoaDTO);
        this._customForBuilder.update(this.formGroup, resultado)
        this.formGroup.disable();
        new ConcessionarioPessoaBuilder(this._activatedRoute, this._dialogFactory, this._router).build(resultado);
      }
    }
    catch (error) {
      console.error(error);
      this._dialogFactory.snack(error.detail || error.message, 'OK', DialogFactory.SNACK_ERROR, { duration: 3000 });
    }
  }

  buildSituacao(concessionarioPessoaDTO: ConcessionarioPessoaDTO) {
    if (concessionarioPessoaDTO != undefined)
      return concessionarioPessoaDTO.stConcessionarioPessoa = ConcessionarioPessoaStatus.ATIVO;
  }

  get nmTitulo() {
    if (this.concessionarioPessoaDTO.tpVinculo == ConcessionarioPessoaTipoVinculo.AUXILIAR)
      return this.reativar = 'Ativar Motorista Auxiliar'

    return this.reativar = 'Ativar Representante'
  }

  setDtAtivacao() {
    return !this.concessionarioPessoaDTO.dtAtivacao ? this.concessionarioPessoaDTO.dtAtivacao = new Date() : '';
  }
}